import React, { useRef } from 'react';
import AccountantsHeroSection from '../../../components/landingPage/AccountantsPage/AccountantsHeroSection';
import AccountantsHowItWorks from '../../../components/landingPage/AccountantsPage/AccountantsHowItWorks';
import AccountantsQuotesSection from '../../../components/landingPage/AccountantsPage/AccountantsQuotesSection';
import AccountantsCtaSection from '../../../components/landingPage/AccountantsPage/AccountantsCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const LandingHomeAccountant = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <AccountantsHeroSection />
            <AccountantsHowItWorks />
            <AccountantsQuotesSection />
            <AccountantsCtaSection />
        </div>
    );
};

export default LandingHomeAccountant;
